// extracted by mini-css-extract-plugin
module.exports = {"Card":"styles_Card__K8TVx"};